<mat-card-content>
    <mat-accordion #accordion="matAccordion" [multi]="true" expanded="true">
        <mat-expansion-panel [(expanded)]="isExpanded">
            <mat-expansion-panel-header>
                <mat-panel-title class="mat-panel-title border-0 m-0 p-0">
                    <span class="mat-panel-title">{{'title.enterprise_group_customer' |translate}}
                        <span *ngIf="isView">({{dataSource.data.length}})</span>
                    </span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="!isView" class="row">
                <div class="col-sm-12">
                    <div class="pb-2">
                        <span style="border: none !important;" class="mat-panel-title">{{'title.search_group_customer'
                            |translate}}</span>
                    </div>
                </div>
                <div class="col-sm-12" style="padding: 0 12px 0 12px !important;margin-bottom: 15px;">
                    <div>
                        <nz-input-group >
                            <input nz-input [disabled]="isDisabledInput()" [(ngModel)]="inputGroupValue" (input)="onChangeGroupSignSearch($event)"
                                (focusOut)="inputGroupValue = inputGroupValue?.trim"
                                [nzAutocomplete]="autoGroupSearching" [ngModelOptions]="{ standalone: true }"
                                placeholder="{{'search_form.group_search_placeholder' | translate}}" id="inputGroup"
                                maxlength="200" nzServerSearch nzShowSearch nzAllowClear />
                            <nz-autocomplete #autoGroupSearching>
                                <nz-auto-option *ngFor="let group of filteredGroupOptions"
                                    (selectionChange)="autocompleteGroupSelected($event, group)" [nzValue]="''">
                                    {{group.name}}
                                </nz-auto-option>
                                <nz-auto-option *ngIf="filteredGroupOptions.length == 0 && inputGroupValue" nzDisabled
                                    nzCustomContent>
                                    <div style="padding: 6px; text-align: center; color: black">
                                        {{'messages.data_not_found' |
                                        translate}}</div>
                                </nz-auto-option>
                                <nz-auto-option *ngIf="filteredGroupOptions.length == 0 && inputGroupValue" nzDisabled
                                    nzCustomContent>
                                </nz-auto-option>
                            </nz-autocomplete>
                        </nz-input-group>
                    </div>
                </div>
            </div>
            <div *ngIf="!isView" class="row align-items-center mt-2 mb-2">
                <div class="col-sm-8">
                    <div class="pb-2">
                        <span style="border: none !important;"
                            class="mat-panel-title">{{'title.enterprise_group_customer'
                            |translate}}({{dataSource.data.length}})</span>
                    </div>
                </div>
            </div>
            <div class="mat-table-container">
                <mat-table [dataSource]="dataSource" width="100%">
                    <!-- STT -->
                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef
                            class="special mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                            <div>{{'enterprise_contract.table_headers.No' | translate}}</div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" [ngClass]="checkIndexOfElement(element) ? 'backgroud-odd' : 'backgroud-even'"
                            class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                            (click)="$event.stopPropagation()">
                            {{dataSource.filteredData.indexOf(element)+1}}
                        </mat-cell>
                    </ng-container>

                    <!-- group name -->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef [ngClass]="!isView ? 'mat-cell-non-boder-right-bottom' : ''"
                            class=" special mat-header-cell-center" style="width: 20% !important">
                            <div style="width: 95% !important;"> {{'enterprise_customer_management.group_customer_header.group_customer_name_2' |
                                translate}}
                            </div>
                            <i class="fa fa-filter pull-right" aria-hidden="true"
                                    (click)="openFilter(); $event.stopPropagation()"
                                    matTooltip="{{ 'button.filter' | translate }}"
                                    style="margin-right: 7px; color: rgb(238 0 51); font-size: 18px; cursor: pointer;"></i>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" matTooltip="{{checkEnterpriseName(element)}}"
                            [ngClass]="{'mat-cell-non-boder-right-bottom' : !isView, 'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}" style="width: 20% !important"
                            (click)="$event.stopPropagation()">
                            {{checkEnterpriseName(element)}}
                        </mat-cell>
                    </ng-container>

                    <!-- Tác động -->
                    <!-- Setting Column -->
                    <ng-container matColumnDef="action" class="mat-column-symbol">
                        <mat-header-cell *matHeaderCellDef [ngClass]="isView ? 'd-none' : ''"
                            class="mat-header-cell-center mat-cell-non-boder-bottom" style="max-width: 100px;">
                            {{'headertable.action' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" [ngClass]="{'d-none' : isView ,'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                            class="mat-header-cell-center mat-cell-non-boder-bottom" style="max-width: 100px;">
                            <button mat-icon-button type="button" (click)="removeGroup(element.id, checkEnterpriseName(element))" appTrackEvent="w.btn.them_moi_kh.xoa_nhom_kh"
                                [disabled]="commonService.getIsLockedEnterprise() || isDisabledInput()">
                                <i class="fa fa-trash" aria-hidden="true"
                                    [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise() || isDisabledInput() }"
                                    matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <!-- filter -->
                    <!-- STT -->
                    <ng-container matColumnDef="stt">
                        <mat-header-cell *matHeaderCellDef
                            class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                        </mat-header-cell>
                    </ng-container>

                    <!-- Tên khách hàng -->
                    <ng-container matColumnDef="filterName">
                        <mat-header-cell *matHeaderCellDef style="width: 30%;"
                            [ngClass]="!isView ? 'mat-cell-non-boder-right-bottom' : ''">
                            <input style="width: 100%;" nz-input id="filter" (focusout)="name = name.trim()"
                                (change)="loadData()" (keydown.enter)="$event.stopPropagation(); $event.preventDefault" [(ngModel)]="name"
                                [placeholder]="'enterprise_customer_management.filter.name' | translate">
                        </mat-header-cell>
                    </ng-container>

                    <!-- Tác động -->
                    <!-- Setting Column -->
                    <ng-container matColumnDef="actionFilter" class="mat-column-symbol">
                        <mat-header-cell [ngClass]="isView ? 'd-none' : ''" *matHeaderCellDef
                            class="mat-header-cell-center mat-cell-non-boder-bottom" style="max-width: 100px;">
                        </mat-header-cell>
                    </ng-container>
                    <!-- <mat-header-row class="row-special " *matHeaderRowDef="displayedFirstColumns; sticky: true"></mat-header-row> -->
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                    <mat-header-row style="background: white !important;" [ngClass]="isShowFilter ? '' : 'd-none'"
                        *matHeaderRowDef="filterRow"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns; let index" matRipple class="element-row"></mat-row>
                </mat-table>
                <nav aria-label="Page navigation" class="mt-2">
                    <ul class="pagination d-flex flex-wrap justify-content-end pagination-sm">
                        <!-- Change page size -->
                        <li class="pagination-text w-100 text-center" *ngIf="dataSource.data.length == 0">
                            {{'form.no_record' | translate}}
                        </li>
                    </ul>
                </nav>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</mat-card-content>
